import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop Component
 * Automatically scrolls to the top of the page whenever the route changes
 * 
 * Usage: Place this component inside your Router in App.tsx:
 * 
 * <BrowserRouter>
 *   <ScrollToTop />
 *   <Routes>
 *     ...your routes
 *   </Routes>
 * </BrowserRouter>
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when pathname changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // Use "instant" for immediate scroll, "smooth" for animated
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
